import { useNavigate } from "react-router-dom";

import { addModalToHref, addParamToHref } from "../../helpers/routes";
import { useAuth } from "../../providers/AuthProvider";
import APButton from "./APButton";

const APContactHelpButton = ({
  textOverride,
  regardingOpportunityId,
  quoteId,
}: {
  textOverride?: string;
  regardingOpportunityId?: string;
  quoteId?: string;
}) => {
  const { getScopedPageUrl } = useAuth();
  const navigate = useNavigate();

  const getModalUrl = () => {
    let linkTo = addModalToHref(
      getScopedPageUrl("modalContactHelp"),
      window.location.href
    );

    if (regardingOpportunityId) {
      linkTo = addParamToHref(
        "modal.opportunityId",
        regardingOpportunityId,
        linkTo
      );
    }
    if (quoteId) {
      linkTo = addParamToHref("modal.quoteId", quoteId, linkTo);
    }

    return linkTo;
  };

  return (
    <APButton
      text={textOverride || "Help"}
      color="tertiaryGreen"
      variant="contained"
      icon="help"
      onClick={() => {
        navigate(getModalUrl(), { replace: true });
      }}
    />
  );
};

export default APContactHelpButton;
